// Getters
export const campaign = (state) => {
  return state.campaign.data || []
}
export const campaignLoading = (state) => {
  return state.campaign.loading
}
export const campaignLastUpdate = (state) => {
  return state.campaign.lastUpdate
}

export const campaignFiles = (state) => {
  return state.campaignFiles.data || []
}
export const campaignFilesLoading = (state) => {
  return state.campaignFiles.loading
}
export const campaignFilesLastUpdate = (state) => {
  return state.campaignFiles.lastUpdate
}
export const participantsCampaign = (state) => {
  return state.participantsCampaign.data || []
}
export const participantsCampaignLoading = (state) => {
  return state.participantsCampaign.loading
}
export const participantsCampaignLastUpdate = (state) => {
  return state.participantsCampaign.lastUpdate
}

